import { render } from "./BestEstimates.vue?vue&type=template&id=3bb347f5&scoped=true"
import script from "./BestEstimates.vue?vue&type=script&lang=js"
export * from "./BestEstimates.vue?vue&type=script&lang=js"

import "./BestEstimates.vue?vue&type=style&index=0&id=3bb347f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb347f5"]])

export default __exports__